export const formatSearch = (search) => {
  const {
    page_num,
    page_size,
    dialog_case_group_id,
    dialog_case_name,
    channel,
    creator,
    cnick,
    create_begin_time,
    create_end_time,
  } = search
  return {
    page: {
      page_num,
      page_size,
    },
    dialog_case_group_id,
    dialog_case_name,
    channel,
    creator,
    cnick,
    create_begin_time,
    create_end_time,
  }
}

export const formatUpdate = (search) => {
  const {
    name,
    cnick,
    case_id,
    description,
    creator_name,
    type_name,
    seller_nick,
    snick,
    order_status,
    order_id,
    id,
  } = search
  return {
    dialog_case: {
      content: {
        cnick,
        snick,
      },
      name,
      group_info: {
        id: case_id && case_id.length ? case_id[case_id.length - 1] : undefined,
        name: '',
      },
      id,
      description,
      creator_name,
      type_name,
      order_info: {
        order_id,
        order_status,
      },
      shop_info: {
        seller_nick,
      },
    },
  }
}

export const getCaseId = (departmentList: any, checkedId: string) => {
  // console.log(departmentList,checkedId);
  const fm = (obj: any, arr: any[]) => {
    const temp: any = []
    const fn = (obj: any, newArr: any) => {
      const tempArr = newArr.slice(0)
      tempArr.push(obj)
      if (checkedId === obj?.id) {
        arr.push(tempArr)
      } else if (obj?.sub_groups && obj?.sub_groups.length) {
        obj?.sub_groups.forEach((m: any) => {
          fn(m, tempArr)
        })
      }
    }
    fn(obj, temp)
    return arr
  }
  const allArr = fm(departmentList?.[0], [])
  if (allArr && allArr.length) {
    return allArr[0].map((item) => item?.id)
  } else {
    return []
  }
}

export const formatCaseList = (data: any) => {
  const result = data.map((item) => {
    const { content, shop_info, ...rest } = item
    return {
      ...rest,
      ...content,
      ...shop_info,
    }
  })
  return result
}

export const formatValues = (treeData: any) => {
  if (!treeData || treeData.length === 0) {
    return []
  }
  const res = []
  treeData.map((item) => {
    const obj = { label: item?.name, value: item?.id, children: [] }
    obj.children = formatValues(item?.sub_groups)
    res.push(obj)
  })
  return res
}
